<template>
    <div class="banner">
        <div class="title3"><span class="helvetica">Bookshop</span> →</div>
        <div v-if="data?.books" class="thumbnails-container">
            <div class="book" v-for="book in data?.books">
                <div class="filler"></div>
                <Image :image="book.cover" :height="100" :width="100" :mobileWidth="500" :mobileHeight="500" imageClass="cover" />
            </div>
        </div>
        <NuxtLink class="overlink" :to="{ name: 'publications-bookshop' }"></NuxtLink>
    </div>
</template>

<script setup lang="ts">
const { getBookshopBanner } = usePublications();
const { data } = useLazyAsyncData(() => getBookshopBanner()); 
</script>

<style lang="scss" scoped>
.banner {
    position: relative;
    margin: var(--size-gutter-sections) var(--size-margin-page) 0 var(--size-margin-page);
    background-color: var(--color-sand-light);

    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--size-margin-page);
    padding: var(--size-gutter-default);

    .title3 {
        color: var(--color-primary);
    }

    .thumbnails-container {
        display: grid;
        grid-template-columns: repeat(5, minmax(0, 1fr));
        gap: var(--size-gutter-small);

        .book {
            position: relative;

            .filler {
                padding-top: 100%;
            }

            &:deep(.responsivePicture) {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
            }
        }
    }
}

@media screen and (max-width: 600px) {
    .banner {
        display: flex;
        flex-direction: column;


        .title3 {
            order: 2;
        }
        
        .thumbnails-container {
            order: 1;

            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: var(--size-gutter-default);

            .book {

                &:last-of-type {
                    display: none;
                }
            }
        }
    }
}
</style>